(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dachrinnen-finder-teaser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dachfinder-teaser-model')) {
    customElements.define('dachfinder-teaser-model', class extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('[data-dachfinder-teaser-model]');
        if (!this.canvas) return;
        this.context = this.canvas.getContext('2d');
        this.targetYaw = -0.58;
        this.yaw = this.targetYaw;
        this.pointerActive = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this.canvas);
        this.addEventListener('pointermove', (event) => this.handlePointerMove(event));
        this.addEventListener('pointerleave', () => {
          this.pointerActive = false;
          this.targetYaw = -0.58;
          this.startAnimation();
        });
        this.resize();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.animationFrame);
      }

      handlePointerMove(event) {
        const bounds = this.getBoundingClientRect();
        const position = (event.clientX - bounds.left) / bounds.width;
        this.pointerActive = true;
        this.targetYaw = -0.72 + position * 0.3;
        this.startAnimation();
      }

      startAnimation() {
        if (this.reduceMotion || this.animationFrame) {
          this.draw();
          return;
        }
        const update = () => {
          this.yaw += (this.targetYaw - this.yaw) * 0.12;
          this.draw();
          if (Math.abs(this.targetYaw - this.yaw) > 0.001) {
            this.animationFrame = requestAnimationFrame(update);
          } else {
            this.animationFrame = 0;
          }
        };
        this.animationFrame = requestAnimationFrame(update);
      }

      resize() {
        const bounds = this.canvas.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(bounds.width * ratio);
        this.canvas.height = Math.round(bounds.height * ratio);
        this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
        this.width = bounds.width;
        this.height = bounds.height;
        this.draw();
      }

      draw() {
        if (!this.context || !this.width || !this.height) return;
        const context = this.context;
        const width = this.width;
        const height = this.height;
        const compact = width < 480;
        const accent = getComputedStyle(this.closest('.dachfinder-teaser')).getPropertyValue('--dachfinder-accent').trim() || '#04bf7b';
        const scale = compact
          ? Math.min(width / 8.4, height / 6.4)
          : Math.min(width / 10, height / 7.4);
        const centerX = width * 0.5;
        const centerY = height * 0.62;
        const halfLength = 1.55 + (4.6 / 10.35) * 2.55;
        const halfDepth = 1.25 + (8.7 / 14.5) * 1.42;
        const leftX = -halfLength;
        const rightX = halfLength;
        const frontY = -halfDepth;
        const backY = halfDepth;
        const wallHeight = 1.48 + (4.6 / 8) * 1.5;
        const ridgeHeight = wallHeight + 1.2;
        const roofLeftX = leftX - 0.18;
        const roofRightX = rightX + 0.18;
        const roofFrontY = frontY - 0.17;
        const roofBackY = backY + 0.17;
        const cosine = Math.cos(this.yaw);
        const sine = Math.sin(this.yaw);

        context.clearRect(0, 0, width, height);

        const project = ([x, y, z]) => {
          const rotatedX = x * cosine - y * sine;
          const rotatedY = x * sine + y * cosine;
          return {
            x: centerX + rotatedX * scale,
            y: centerY + (rotatedY * 0.44 - z) * scale,
            depth: rotatedY
          };
        };

        const polygon = (points, fill, stroke = 'rgba(255,255,255,0.28)', lineWidth = 1) => {
          const projected = points.map(project);
          context.beginPath();
          projected.forEach((point, index) => {
            if (index === 0) context.moveTo(point.x, point.y);
            else context.lineTo(point.x, point.y);
          });
          context.closePath();
          context.fillStyle = fill;
          context.fill();
          context.strokeStyle = stroke;
          context.lineWidth = lineWidth;
          context.stroke();
        };

        const line = (points, color, lineWidth = 1, dash = []) => {
          const projected = points.map(project);
          context.save();
          context.beginPath();
          projected.forEach((point, index) => {
            if (index === 0) context.moveTo(point.x, point.y);
            else context.lineTo(point.x, point.y);
          });
          context.strokeStyle = color;
          context.lineWidth = lineWidth;
          context.lineCap = 'round';
          context.lineJoin = 'round';
          context.setLineDash(dash);
          context.stroke();
          context.restore();
        };

        const edge = 'rgba(255,255,255,0.26)';
        const surfaces = [
          {
            points: [[leftX, backY, 0], [rightX, backY, 0], [rightX, backY, wallHeight], [leftX, backY, wallHeight]],
            fill: 'rgba(235,237,230,0.9)'
          },
          {
            points: [[leftX, frontY, 0], [rightX, frontY, 0], [rightX, frontY, wallHeight], [leftX, frontY, wallHeight]],
            fill: 'rgba(218,222,214,0.86)'
          },
          {
            points: [[leftX, frontY, 0], [leftX, backY, 0], [leftX, backY, wallHeight], [leftX, 0, ridgeHeight], [leftX, frontY, wallHeight]],
            fill: 'rgba(238,240,233,0.94)'
          },
          {
            points: [[rightX, frontY, 0], [rightX, backY, 0], [rightX, backY, wallHeight], [rightX, 0, ridgeHeight], [rightX, frontY, wallHeight]],
            fill: 'rgba(226,229,222,0.9)'
          },
          {
            points: [[roofLeftX, roofFrontY, wallHeight], [roofRightX, roofFrontY, wallHeight], [roofRightX, 0, ridgeHeight], [roofLeftX, 0, ridgeHeight]],
            fill: 'rgba(24,27,27,0.98)',
            stroke: 'rgba(255,255,255,0.46)'
          },
          {
            points: [[roofLeftX, roofBackY, wallHeight], [roofRightX, roofBackY, wallHeight], [roofRightX, 0, ridgeHeight], [roofLeftX, 0, ridgeHeight]],
            fill: 'rgba(16,19,19,0.96)',
            stroke: 'rgba(255,255,255,0.32)'
          }
        ];

        surfaces
          .map((surface) => ({
            ...surface,
            depth: surface.points.reduce((sum, point) => sum + project(point).depth, 0) / surface.points.length
          }))
          .sort((first, second) => first.depth - second.depth)
          .forEach((surface) => polygon(surface.points, surface.fill, surface.stroke || edge));

        const leftFaceVisible = project([leftX, 0, wallHeight * 0.5]).depth >= project([rightX, 0, wallHeight * 0.5]).depth;
        const backFaceVisible = project([0, backY, wallHeight * 0.5]).depth >= project([0, frontY, wallHeight * 0.5]).depth;
        const facadeY = backY + 0.025;
        const sideX = leftX - 0.025;
        const windowBottom = wallHeight * 0.34;
        const windowTop = wallHeight * 0.72;
        const windowHalfWidth = Math.min(0.72, halfLength * 0.2);

        const drawFacadeWindow = (center) => {
          polygon(
            [
              [center - windowHalfWidth, facadeY, windowBottom],
              [center + windowHalfWidth, facadeY, windowBottom],
              [center + windowHalfWidth, facadeY, windowTop],
              [center - windowHalfWidth, facadeY, windowTop]
            ],
            'rgba(95,139,150,0.42)',
            'rgba(245,247,241,0.88)',
            2
          );
          line([[center, facadeY + 0.01, windowBottom], [center, facadeY + 0.01, windowTop]], 'rgba(245,247,241,0.72)', 1);
          line(
            [
              [center - windowHalfWidth, facadeY + 0.01, windowBottom + (windowTop - windowBottom) * 0.52],
              [center + windowHalfWidth, facadeY + 0.01, windowBottom + (windowTop - windowBottom) * 0.52]
            ],
            'rgba(245,247,241,0.62)',
            1
          );
          line(
            [
              [center - windowHalfWidth * 0.82, facadeY + 0.015, windowTop - 0.06],
              [center + windowHalfWidth * 0.22, facadeY + 0.015, windowBottom + 0.08]
            ],
            'rgba(255,255,255,0.18)',
            1
          );
        };

        if (backFaceVisible) {
          polygon(
            [[leftX, facadeY, 0.02], [rightX, facadeY, 0.02], [rightX, facadeY, 0.15], [leftX, facadeY, 0.15]],
            'rgba(33,37,36,0.62)',
            'rgba(255,255,255,0.18)'
          );

          drawFacadeWindow(-halfLength * 0.58);
          drawFacadeWindow(halfLength * 0.5);

          const doorCenter = -halfLength * 0.1;
          const doorHalfWidth = Math.min(0.42, halfLength * 0.12);
          const doorTop = wallHeight * 0.8;
          polygon(
            [
              [doorCenter - doorHalfWidth, facadeY + 0.01, 0.06],
              [doorCenter + doorHalfWidth, facadeY + 0.01, 0.06],
              [doorCenter + doorHalfWidth, facadeY + 0.01, doorTop],
              [doorCenter - doorHalfWidth, facadeY + 0.01, doorTop]
            ],
            'rgba(222,226,217,0.96)',
            'rgba(250,250,244,0.94)',
            2
          );
          line(
            [[doorCenter - doorHalfWidth * 0.36, facadeY + 0.02, 0.1], [doorCenter - doorHalfWidth * 0.36, facadeY + 0.02, doorTop]],
            'rgba(250,250,244,0.74)',
            1.5
          );
          line(
            [[doorCenter + doorHalfWidth * 0.62, facadeY + 0.035, doorTop * 0.46], [doorCenter + doorHalfWidth * 0.77, facadeY + 0.035, doorTop * 0.46]],
            accent,
            2
          );

          const canopyHalfWidth = doorHalfWidth + 0.2;
          const canopyZ = doorTop + 0.18;
          polygon(
            [
              [doorCenter - canopyHalfWidth, facadeY, canopyZ],
              [doorCenter + canopyHalfWidth, facadeY, canopyZ],
              [doorCenter + canopyHalfWidth + 0.08, backY + 0.42, canopyZ - 0.07],
              [doorCenter - canopyHalfWidth - 0.08, backY + 0.42, canopyZ - 0.07]
            ],
            'rgba(144,190,190,0.18)',
            'rgba(245,247,241,0.72)',
            1.5
          );
          line(
            [[doorCenter - canopyHalfWidth - 0.08, backY + 0.42, canopyZ - 0.07], [doorCenter - canopyHalfWidth, facadeY, doorTop - 0.02]],
            'rgba(245,247,241,0.5)',
            1
          );
          line(
            [[doorCenter + canopyHalfWidth + 0.08, backY + 0.42, canopyZ - 0.07], [doorCenter + canopyHalfWidth, facadeY, doorTop - 0.02]],
            'rgba(245,247,241,0.5)',
            1
          );
        }

        if (leftFaceVisible) {
          polygon(
            [[sideX, frontY, 0.02], [sideX, backY, 0.02], [sideX, backY, 0.15], [sideX, frontY, 0.15]],
            'rgba(27,31,30,0.5)',
            'rgba(255,255,255,0.15)'
          );

          const sideWindowHalfWidth = Math.min(0.34, halfDepth * 0.16);
          [-halfDepth * 0.42, halfDepth * 0.34].forEach((windowCenterY) => {
            polygon(
              [
                [sideX, windowCenterY - sideWindowHalfWidth, wallHeight * 0.36],
                [sideX, windowCenterY + sideWindowHalfWidth, wallHeight * 0.36],
                [sideX, windowCenterY + sideWindowHalfWidth, wallHeight * 0.77],
                [sideX, windowCenterY - sideWindowHalfWidth, wallHeight * 0.77]
              ],
              'rgba(80,125,137,0.38)',
              'rgba(246,247,241,0.76)',
              1.5
            );
            line(
              [[sideX - 0.01, windowCenterY, wallHeight * 0.36], [sideX - 0.01, windowCenterY, wallHeight * 0.77]],
              'rgba(246,247,241,0.62)',
              1
            );
          });
        }

        const visibleRoofY = backFaceVisible ? roofBackY : roofFrontY;
        for (let row = 1; row <= 6; row += 1) {
          const progress = row / 7;
          const y = visibleRoofY + (0 - visibleRoofY) * progress;
          const z = wallHeight + (ridgeHeight - wallHeight) * progress;
          line(
            [[roofLeftX, y, z + 0.008], [roofRightX, y, z + 0.008]],
            'rgba(255,255,255,0.13)',
            row === 6 ? 1.4 : 1
          );
        }

        for (let column = 1; column < 13; column += 1) {
          const x = roofLeftX + ((roofRightX - roofLeftX) / 13) * column;
          line([[x, visibleRoofY, wallHeight + 0.01], [x, 0, ridgeHeight + 0.01]], 'rgba(255,255,255,0.095)', 0.8);
        }

        line([[roofLeftX, visibleRoofY, wallHeight], [roofRightX, visibleRoofY, wallHeight]], 'rgba(246,247,240,0.72)', 3);
        const visibleRoofX = leftFaceVisible ? roofLeftX : roofRightX;
        line(
          [[visibleRoofX, roofFrontY, wallHeight], [visibleRoofX, 0, ridgeHeight], [visibleRoofX, roofBackY, wallHeight]],
          'rgba(246,247,240,0.82)',
          3
        );
        line([[roofLeftX, 0, ridgeHeight], [roofRightX, 0, ridgeHeight]], 'rgba(255,255,255,0.52)', 2.5);

        const visibleWallY = backFaceVisible ? backY : frontY;
        for (let rafter = 1; rafter < 12; rafter += 1) {
          const x = roofLeftX + ((roofRightX - roofLeftX) / 12) * rafter;
          line(
            [[x, visibleRoofY, wallHeight - 0.01], [x, visibleWallY, wallHeight - 0.13]],
            'rgba(246,247,240,0.38)',
            1.4
          );
        }

        const gutterY = backY + 0.06;
        const downpipeX = rightX - 0.08;
        const downpipeElbowY = backY + 0.18;
        line([[leftX, gutterY, wallHeight], [rightX, gutterY, wallHeight]], accent, compact ? 5.5 : 7);
        line([[leftX, gutterY, wallHeight + 0.01], [rightX, gutterY, wallHeight + 0.01]], 'rgba(255,255,255,0.58)', 1);
        line(
          [
            [downpipeX, gutterY, wallHeight],
            [downpipeX, downpipeElbowY, wallHeight - 0.28],
            [downpipeX, downpipeElbowY, 0.18]
          ],
          accent,
          compact ? 5.5 : 7
        );

        const gutterStart = project([leftX, gutterY, wallHeight]);
        const gutterEnd = project([rightX, gutterY, wallHeight]);
        context.fillStyle = accent;
        [gutterStart, gutterEnd].forEach((point) => {
          context.beginPath();
          context.arc(point.x, point.y, compact ? 3.5 : 4.5, 0, Math.PI * 2);
          context.fill();
        });

        line(
          [[leftX - 0.35, frontY - 0.25, -0.25], [rightX + 0.35, frontY - 0.25, -0.25]],
          'rgba(255,255,255,0.18)',
          1,
          [4, 6]
        );

        const dimensionY = backY + 0.58;
        const slopeX = roofLeftX - 0.34;
        line([[leftX, backY, -0.04], [leftX, dimensionY, -0.14]], 'rgba(255,255,255,0.26)', 1, [3, 4]);
        line([[rightX, backY, -0.04], [rightX, dimensionY, -0.14]], 'rgba(255,255,255,0.26)', 1, [3, 4]);
        line([[leftX, dimensionY, -0.14], [rightX, dimensionY, -0.14]], 'rgba(255,255,255,0.82)', 1.4);
        line([[roofLeftX, roofBackY, wallHeight], [slopeX, roofBackY, wallHeight]], 'rgba(255,255,255,0.26)', 1, [3, 4]);
        line([[roofLeftX, 0, ridgeHeight], [slopeX, 0, ridgeHeight]], 'rgba(255,255,255,0.26)', 1, [3, 4]);
        line([[slopeX, roofBackY, wallHeight], [slopeX, 0, ridgeHeight]], 'rgba(255,255,255,0.82)', 1.4);

        const drawLabel = (point, key, value) => {
          const labelPoint = project(point);
          const keyWidth = compact ? 20 : 23;
          const heightValue = compact ? 20 : 23;
          const valueWidth = compact ? 64 : 75;
          const left = Math.max(4, Math.min(width - keyWidth - valueWidth - 4, labelPoint.x));
          const top = Math.max(4, Math.min(height - heightValue - 4, labelPoint.y));
          context.fillStyle = 'rgba(24,27,26,0.96)';
          context.fillRect(left, top, keyWidth + valueWidth, heightValue);
          context.strokeStyle = 'rgba(255,255,255,0.26)';
          context.strokeRect(left + 0.5, top + 0.5, keyWidth + valueWidth - 1, heightValue - 1);
          context.fillStyle = accent;
          context.fillRect(left, top, keyWidth, heightValue);
          context.fillStyle = '#07130f';
          context.font = `900 ${compact ? 10 : 11}px Barlow, sans-serif`;
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          context.fillText(key, left + keyWidth * 0.5, top + heightValue * 0.5);
          context.fillStyle = '#ffffff';
          context.font = `700 ${compact ? 8 : 9}px Barlow, sans-serif`;
          context.textAlign = 'left';
          context.fillText(value, left + keyWidth + 7, top + heightValue * 0.5);
        };

        drawLabel([-0.72, dimensionY + 0.08, -0.18], 'A', 'Dachl\u00e4nge');
        drawLabel([slopeX - 0.28, roofBackY * 0.45, wallHeight + (ridgeHeight - wallHeight) * 0.48], 'B', 'Dachschr\u00e4ge');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dachrinnen-konfigurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gutter-finder')) {
    customElements.define('gutter-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.state = {
          step: 1,
          route: '',
          building: 'house',
          measure: 4.6,
          roofLength: 4.6,
          roofDepth: 8.7,
          facadeHeight: 4.6,
          roofArea: 40,
          nominalSize: 280,
          pipeSize: 80,
          yaw: -0.58,
          camera: {
            zoom: 1,
            focusX: 0,
            focusY: 0,
            focusZ: 0
          },
          focusMode: 'complete',
          focusStartedAt: 0,
          dragging: false,
          dragX: 0
        };

        this.routeNames = {
          complete: 'Komplett-System',
          gutter: 'Rinne & Zubehör',
          downpipe: 'Fallrohr & Zubehör'
        };

        this.buildingNames = {
          house: 'Haus',
          garage: 'Garage',
          carport: 'Carport',
          shed: 'Gartenhaus'
        };

        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progressSteps = Array.from(this.querySelectorAll('[data-step-jump]'));
        this.routeButtons = Array.from(this.querySelectorAll('[data-route]'));
        this.buildingButtons = Array.from(this.querySelectorAll('[data-building]'));
        this.canvas = this.querySelector('[data-model-canvas]');
        this.canvasWrap = this.canvas.parentElement;
        this.stage = this.querySelector('.gutter-finder__stage');
        this.modelFocus = this.querySelector('[data-model-focus]');
        this.modelFocusLabel = this.querySelector('[data-model-focus-label]');
        this.context = this.canvas.getContext('2d');
        this.measureInput = this.querySelector('[data-measure-input]');
        this.measureRange = this.querySelector('[data-measure-range]');
        this.measureKey = this.querySelector('[data-measure-key]');
        this.roofLengthInput = this.querySelector('[data-roof-length]');
        this.roofDepthInput = this.querySelector('[data-roof-depth]');
        this.roofAreaOutput = this.querySelector('[data-roof-area]');

        this.routeButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectRoute(button.dataset.route));
        });

        this.buildingButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectBuilding(button.dataset.building));
        });

        this.querySelectorAll('[data-next]').forEach((button) => {
          button.addEventListener('click', () => this.goToStep(this.state.step + 1));
        });

        this.querySelectorAll('[data-back]').forEach((button) => {
          button.addEventListener('click', () => this.goToStep(this.state.step - 1));
        });

        this.querySelector('[data-result]').addEventListener('click', () => {
          this.renderResult();
          this.goToStep(4);
        });

        this.querySelector('[data-restart]').addEventListener('click', () => this.goToStep(1));

        this.progressSteps.forEach((button) => {
          button.addEventListener('click', () => {
            const target = Number(button.dataset.stepJump);
            if (!button.disabled && target <= this.state.step) this.goToStep(target);
          });
        });

        this.measureInput.addEventListener('focus', () => this.selectInputValue(this.measureInput));
        this.roofLengthInput.addEventListener('focus', () => this.selectInputValue(this.roofLengthInput));
        this.roofDepthInput.addEventListener('focus', () => this.selectInputValue(this.roofDepthInput));
        this.measureInput.addEventListener('input', () => this.updateMeasure(this.measureInput.value));
        this.measureRange.addEventListener('input', () => this.updateMeasure(this.measureRange.value));
        this.measureInput.addEventListener('change', () => this.normalizeMeasure());
        this.roofLengthInput.addEventListener('input', () => this.updateRoofLength(this.roofLengthInput.value));
        this.roofDepthInput.addEventListener('input', () => this.updateRoofDepth(this.roofDepthInput.value));
        this.roofLengthInput.addEventListener('change', () => this.normalizeRoofDimension('roofLength', this.roofLengthInput, 10.35));
        this.roofDepthInput.addEventListener('change', () => this.normalizeRoofDimension('roofDepth', this.roofDepthInput, 14.5));

        this.canvasWrap.addEventListener('pointerdown', (event) => this.startDrag(event));
        window.addEventListener('pointermove', (event) => this.moveDrag(event));
        window.addEventListener('pointerup', () => this.endDrag());

        this.resizeObserver = new ResizeObserver(() => this.resizeCanvas());
        this.resizeObserver.observe(this.canvasWrap);
        this.resizeCanvas();
        this.syncInterface();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.cameraAnimationFrame) cancelAnimationFrame(this.cameraAnimationFrame);
        if (this.focusTimer) clearTimeout(this.focusTimer);
        if (this.stageTimer) clearTimeout(this.stageTimer);
      }

      selectRoute(route) {
        this.state.route = route;
        this.state.measure = route === 'downpipe' ? this.state.facadeHeight : this.state.roofLength;
        this.routeButtons.forEach((button) => {
          const selected = button.dataset.route === route;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        this.querySelector('[data-step="1"] [data-next]').disabled = false;
        this.syncInterface();
        const labels = {
          complete: 'Rinne & Fallrohr im System',
          gutter: 'Zoom auf die Dachrinne',
          downpipe: 'Zoom auf das Fallrohr'
        };
        this.focusModel(route, labels[route]);
      }

      selectBuilding(building) {
        this.state.building = building;
        this.buildingButtons.forEach((button) => {
          const selected = button.dataset.building === building;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        this.syncInterface();
        this.focusModel('building', `${this.buildingNames[building]} ausgewählt`);
      }

      goToStep(step) {
        const safeStep = Math.max(1, Math.min(4, step));
        if (safeStep > 1 && !this.state.route) return;
        this.state.step = safeStep;

        this.steps.forEach((panel) => {
          const active = Number(panel.dataset.step) === safeStep;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        this.progressSteps.forEach((button, index) => {
          const number = index + 1;
          button.disabled = number > safeStep;
          button.classList.toggle('is-current', number === safeStep);
          button.classList.toggle('is-complete', number < safeStep);
          if (number === safeStep) {
            button.setAttribute('aria-current', 'step');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        this.querySelector('[data-progress-value]').style.width = `${((safeStep - 1) / 3) * 100}%`;
        this.syncInterface();
        if (safeStep === 3) {
          const mode = this.state.route === 'gutter' ? 'gutter' : this.state.route === 'downpipe' ? 'downpipe' : 'complete';
          const label = mode === 'gutter' ? 'Dachrinne vermessen' : mode === 'downpipe' ? 'Fallrohr vermessen' : 'System vermessen';
          this.focusModel(mode, label);
        }
        if (safeStep === 2) {
          this.focusModel('building', `${this.buildingNames[this.state.building]} in der Gesamtansicht`);
        }
        if (safeStep === 4) {
          const mode = this.state.route === 'downpipe' ? 'downpipe' : this.state.route === 'gutter' ? 'gutter' : 'complete';
          this.focusModel(mode, 'Empfehlung visualisiert');
        }
        this.querySelector(`[data-step="${safeStep}"]`).focus({ preventScroll: true });
      }

      updateMeasure(rawValue) {
        const parsed = this.parseDecimalInput(rawValue);
        if (parsed === null) return;
        const max = this.state.route === 'downpipe' ? 8 : 10.35;
        this.state.measure = Math.max(1, Math.min(max, parsed));
        if (this.state.route === 'downpipe') {
          this.state.facadeHeight = this.state.measure;
        } else {
          this.state.roofLength = this.state.measure;
        }
        this.measureRange.value = this.state.measure;
        this.syncInterface();
      }

      normalizeMeasure() {
        const parsed = this.parseDecimalInput(this.measureInput.value);
        const max = this.state.route === 'downpipe' ? 8 : 10.35;
        if (parsed !== null) this.state.measure = Math.max(1, Math.min(max, parsed));
        this.state.measure = Math.round(this.state.measure * 20) / 20;
        if (this.state.route === 'downpipe') {
          this.state.facadeHeight = this.state.measure;
        } else {
          this.state.roofLength = this.state.measure;
        }
        this.measureInput.value = this.formatEditableNumber(this.state.measure, 2);
        this.measureRange.value = this.state.measure;
        this.syncInterface();
      }

      updateRoofLength(rawValue) {
        const parsed = this.parseDecimalInput(rawValue);
        if (parsed === null) return;
        this.state.roofLength = Math.max(1, Math.min(10.35, parsed));
        if (this.state.route !== 'downpipe') {
          this.state.measure = this.state.roofLength;
          this.measureInput.value = this.state.measure;
          this.measureRange.value = this.state.measure;
        }
        this.updateRoofDimensions();
      }

      updateRoofDepth(rawValue) {
        const parsed = this.parseDecimalInput(rawValue);
        if (parsed === null) return;
        this.state.roofDepth = Math.max(1, Math.min(14.5, parsed));
        this.updateRoofDimensions();
      }

      normalizeRoofDimension(stateKey, input, max) {
        const parsed = this.parseDecimalInput(input.value);
        if (parsed !== null) this.state[stateKey] = Math.max(1, Math.min(max, parsed));
        input.value = this.formatEditableNumber(this.state[stateKey], 2);
        if (stateKey === 'roofLength' && this.state.route !== 'downpipe') {
          this.state.measure = this.state.roofLength;
          this.measureRange.value = this.state.measure;
        }
        this.updateRoofDimensions();
      }

      parseDecimalInput(rawValue) {
        const normalized = String(rawValue).trim().replace(/\s+/g, '').replace(',', '.');
        if (!/^\d*(?:\.\d*)?$/.test(normalized) || normalized === '' || normalized === '.') return null;
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
      }

      formatEditableNumber(value, maximumFractionDigits = 2) {
        return Number(value).toLocaleString('de-DE', {
          useGrouping: false,
          maximumFractionDigits
        });
      }

      selectInputValue(input) {
        requestAnimationFrame(() => input.select());
      }

      updateRoofDimensions() {
        const previousNominalSize = this.state.nominalSize;
        this.syncInterface();
        if (previousNominalSize !== this.state.nominalSize) {
          this.focusModel(
            'complete',
            `System ${this.state.nominalSize} mit Ø ${this.state.pipeSize} mm empfohlen`
          );
        }
      }

      syncSizing() {
        this.state.roofArea = Math.round(this.state.roofLength * this.state.roofDepth * 10) / 10;
        const useLargeSystem = this.state.roofArea > 85;
        this.state.nominalSize = useLargeSystem ? 333 : 280;
        this.state.pipeSize = useLargeSystem ? 100 : 80;
        const status = this.querySelector('[data-size-status]');
        const note = this.querySelector('[data-size-note]');
        this.roofAreaOutput.textContent = `${this.state.roofArea.toFixed(1).replace('.', ',')} m²`;
        this.querySelector('[data-gutter-size]').textContent = this.state.nominalSize;
        this.querySelector('[data-pipe-size]').textContent = `Ø ${this.state.pipeSize} mm`;
        status.textContent = `System ${this.state.nominalSize} empfohlen`;
        note.textContent = useLargeSystem
          ? `Für ${this.state.roofArea} m² wird automatisch die größere Nenngröße 333 empfohlen.`
          : `Für ${this.state.roofArea} m² wird automatisch die Nenngröße 280 empfohlen.`;
      }

      syncInterface() {
        const isDownpipe = this.state.route === 'downpipe';
        const max = isDownpipe ? 8 : 10.35;
        if (this.state.measure > max) this.state.measure = max;
        const value = this.formatMeters(this.state.measure);

        this.querySelector('[data-route-chip]').textContent = this.state.route ? this.routeNames[this.state.route] : 'Projekt wählen';
        this.querySelector('[data-building-chip]').textContent = this.buildingNames[this.state.building];
        const showMeasure = this.state.step >= 3;
        this.querySelector('[data-stage-title]').textContent = showMeasure
          ? `${isDownpipe ? 'Fassadenhöhe' : 'Dachkante'} · ${value}`
          : this.state.step === 2
            ? `${this.buildingNames[this.state.building]} · Vorschau`
            : 'Projektvorschau';
        this.querySelector('[data-dimension-value]').textContent = value;
        this.querySelector('.gutter-finder__dimension').hidden = !showMeasure;

        this.querySelector('[data-measure-heading]').textContent = isDownpipe
          ? 'Wie hoch ist deine Fassade?'
          : 'Wie lang ist deine Dachkante?';
        this.querySelector('[data-measure-copy]').textContent = isDownpipe
          ? 'Miss vom unteren Rohrende bis zum Anschluss unter der Dachrinne.'
          : 'Miss die Seite, an der die Dachrinne montiert werden soll.';
        this.querySelector('[data-measure-label]').textContent = isDownpipe ? 'Fassadenhöhe' : 'Dachlänge';
        this.measureKey.hidden = isDownpipe;
        this.measureInput.setAttribute('aria-label', `${isDownpipe ? 'Fassadenhöhe' : 'Dachlänge'} in Metern`);

        if (Number(this.measureRange.max) !== max) {
          this.measureRange.max = max;
          this.measureRange.value = this.state.measure;
          const scaleLabels = this.querySelectorAll('.gutter-finder__range-scale span');
          scaleLabels[1].textContent = `${String(max).replace('.', ',')} m`;
        }
        const activeInput = this.ownerDocument.activeElement;
        if (activeInput !== this.measureInput) this.measureInput.value = this.formatEditableNumber(this.state.measure);
        this.measureRange.value = this.state.measure;
        if (activeInput !== this.roofLengthInput) this.roofLengthInput.value = this.formatEditableNumber(this.state.roofLength);
        if (activeInput !== this.roofDepthInput) this.roofDepthInput.value = this.formatEditableNumber(this.state.roofDepth);
        const isCarport = this.state.building === 'carport';
        this.querySelector('[data-slope-label]').textContent = isCarport
          ? 'Rinne bis obere Dachkante'
          : 'Rinne bis First';
        this.querySelector('[data-slope-help]').textContent = isCarport
          ? 'B misst du entlang der Schräge – von der Dachrinne bis zur oberen Dachkante. A × B ergibt die entwässerte Dachfläche.'
          : 'B misst du entlang der Schräge – von der Dachrinne bis zum First. A × B ergibt die Dachseite, die in diese Rinne entwässert.';

        this.syncSizing();
        this.drawModel();
      }

      renderResult() {
        const route = this.state.route;
        const measure = this.state.measure;
        const productMedia = this.querySelector('[data-product-media]');
        const productImage = this.querySelector('[data-product-image]');
        const resultLink = this.querySelector('[data-result-link]');
        const resultKicker = this.querySelector('[data-result-kicker]');
        const resultTitle = this.querySelector('[data-result-title]');
        const resultDescription = this.querySelector('[data-result-description]');
        const primaryLabel = this.querySelector('[data-primary-label]');
        const primaryValue = this.querySelector('[data-primary-value]');
        const secondaryLabel = this.querySelector('[data-secondary-label]');
        const secondaryValue = this.querySelector('[data-secondary-value]');
        const tertiaryLabel = this.querySelector('[data-tertiary-label]');
        const tertiaryValue = this.querySelector('[data-tertiary-value]');
        let recommendedProduct;

        if (route === 'complete') {
          const systemLength = Math.min(10.35, Math.max(2.3, Math.ceil(measure / 1.15) * 1.15));
          recommendedProduct = this.getRecommendedProduct(route, systemLength);
          resultKicker.textContent = 'Komplett-System';
          resultTitle.textContent = `${recommendedProduct.title} · bis ${this.formatMeters(systemLength)}`;
          resultDescription.textContent = `Für ${this.state.roofArea} m² empfiehlt der Größen-Check Nenngröße ${this.state.nominalSize} mit Ø ${this.state.pipeSize} mm Fallrohr.`;
          primaryLabel.textContent = 'Dachmaß';
          primaryValue.textContent = this.formatMeters(measure);
          secondaryLabel.textContent = 'Systemstufe';
          secondaryValue.textContent = this.formatMeters(systemLength);
          tertiaryLabel.textContent = 'Systemgröße';
          tertiaryValue.textContent = `NG ${this.state.nominalSize} · Ø ${this.state.pipeSize}`;
        }

        if (route === 'gutter') {
          const elements = Math.ceil(measure / 1.15);
          const coverage = elements * 1.15;
          recommendedProduct = this.getRecommendedProduct(route);
          resultKicker.textContent = 'Rinne & Zubehör';
          resultTitle.textContent = recommendedProduct.title;
          resultDescription.textContent = `Für ${this.state.roofArea} m² wird automatisch Nenngröße ${this.state.nominalSize} empfohlen. Für das Planungsmaß werden ${elements} Rinnenelemente benötigt.`;
          primaryLabel.textContent = 'Dachmaß';
          primaryValue.textContent = this.formatMeters(measure);
          secondaryLabel.textContent = 'Planungsmaß';
          secondaryValue.textContent = this.formatMeters(coverage);
          tertiaryLabel.textContent = 'Nenngröße';
          tertiaryValue.textContent = this.state.nominalSize;
        }

        if (route === 'downpipe') {
          const pipes = Math.ceil(measure);
          recommendedProduct = this.getRecommendedProduct(route);
          resultKicker.textContent = 'Fallrohr & Zubehör';
          resultTitle.textContent = recommendedProduct.title;
          resultDescription.textContent = `Zur empfohlenen Nenngröße ${this.state.nominalSize} passt das Fallrohr mit Ø ${this.state.pipeSize} mm.`;
          primaryLabel.textContent = 'Fassadenhöhe';
          primaryValue.textContent = this.formatMeters(measure);
          secondaryLabel.textContent = 'Rohrstücke';
          secondaryValue.textContent = `${pipes} × 1,00 m`;
          tertiaryLabel.textContent = 'Rohrgröße';
          tertiaryValue.textContent = `Ø ${this.state.pipeSize} mm`;
        }

        resultLink.href = recommendedProduct.url;
        resultLink.firstChild.textContent = 'Direkt zum Produkt ';
        if (recommendedProduct.image) {
          productImage.src = recommendedProduct.image;
          productImage.alt = recommendedProduct.title;
          productMedia.hidden = false;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
          productMedia.hidden = true;
        }
      }

      getRecommendedProduct(route, systemLength) {
        const productKey = route === 'complete'
          ? `complete${this.state.nominalSize}`
          : route === 'gutter'
            ? `gutter${this.state.nominalSize}`
            : `downpipe${this.state.pipeSize}`;
        let url = this.dataset[`${productKey}Url`];
        if (route === 'complete') {
          const availableLengths = [2.3, 3.45, 4.6, 5.75, 6.9, 8.05, 9.2, 10.35];
          const variants = (this.dataset[`${productKey}Variants`] || '').split(',').filter(Boolean);
          const variantIndex = availableLengths.findIndex((length) => Math.abs(length - systemLength) < 0.01);
          if (variantIndex >= 0 && variants[variantIndex]) {
            url = `${url}${url.includes('?') ? '&' : '?'}variant=${variants[variantIndex]}`;
          }
        }
        return {
          url,
          title: this.dataset[`${productKey}Title`],
          image: this.dataset[`${productKey}Image`]
        };
      }

      formatMeters(value) {
        return `${Number(value).toFixed(2).replace('.', ',')} m`;
      }

      resizeCanvas() {
        const rect = this.canvasWrap.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.max(1, Math.round(rect.width * ratio));
        this.canvas.height = Math.max(1, Math.round(rect.height * ratio));
        this.canvas.style.width = `${rect.width}px`;
        this.canvas.style.height = `${rect.height}px`;
        this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
        this.canvasSize = { width: rect.width, height: rect.height };
        this.drawModel();
      }

      startDrag(event) {
        this.state.dragging = true;
        this.state.dragX = event.clientX;
        this.canvasWrap.setPointerCapture(event.pointerId);
      }

      moveDrag(event) {
        if (!this.state.dragging) return;
        const delta = event.clientX - this.state.dragX;
        this.state.dragX = event.clientX;
        this.state.yaw += delta * 0.008;
        this.drawModel();
      }

      endDrag() {
        this.state.dragging = false;
      }

      getModelGeometry() {
        const lengthRatio = Math.min(1, this.state.roofLength / 10.35);
        const depthRatio = Math.min(1, this.state.roofDepth / 14.5);
        const heightRatio = Math.min(1, this.state.facadeHeight / 8);
        const building = this.state.building;
        const measuredHalfLength = 1.55 + lengthRatio * 2.55;
        const measuredHalfDepth = 1.25 + depthRatio * 1.42;
        const shedHalfSize = 1.4 + Math.sqrt(Math.min(1, this.state.roofArea / 150)) * 1.6;
        const halfLength = building === 'shed' ? shedHalfSize : measuredHalfLength;
        const halfDepth = building === 'shed'
          ? shedHalfSize
          : building === 'garage'
            ? measuredHalfDepth * 1.08
            : building === 'carport'
              ? measuredHalfDepth * 0.96
              : measuredHalfDepth;
        const facadeHeight = 1.48 + heightRatio * 1.5;
        const wallHeight = building === 'shed'
          ? facadeHeight * 0.7
          : building === 'garage'
            ? facadeHeight * 0.86
            : building === 'carport'
              ? facadeHeight * 0.84
              : facadeHeight;
        const roofRise = building === 'garage' ? 0.84 : building === 'carport' ? 0.52 : building === 'shed' ? 0.72 : 1.12;
        return {
          building,
          halfLength,
          halfDepth,
          wallHeight,
          roofRise,
          frontY: -halfDepth,
          backY: halfDepth,
          leftX: -halfLength,
          rightX: halfLength
        };
      }

      focusModel(mode, label) {
        const geometry = this.getModelGeometry();
        const downpipeX = geometry.rightX - 0.08;
        const drainageAtFront = geometry.building === 'carport';
        const gutterY = drainageAtFront ? geometry.frontY : geometry.backY;
        const drainageYaw = drainageAtFront ? 2.35 : -0.58;
        const gutterYaw = drainageAtFront ? 2.45 : -0.46;
        const downpipeYaw = drainageAtFront ? 2.25 : -0.34;
        const targets = {
          complete: {
            zoom: geometry.building === 'house' ? 0.94 : 1.1,
            focusX: 0,
            focusY: gutterY * 0.2,
            focusZ: geometry.wallHeight * 0.42,
            yaw: drainageYaw
          },
          gutter: {
            zoom: geometry.building === 'house' ? 1.22 : 1.38,
            focusX: 0,
            focusY: gutterY,
            focusZ: geometry.wallHeight,
            yaw: gutterYaw
          },
          downpipe: {
            zoom: geometry.building === 'house' ? 1.32 : 1.48,
            focusX: downpipeX,
            focusY: gutterY,
            focusZ: geometry.wallHeight * 0.52,
            yaw: downpipeYaw
          },
          building: {
            zoom: geometry.building === 'house' ? 0.98 : geometry.building === 'carport' || geometry.building === 'shed' ? 1.12 : 1.08,
            focusX: 0,
            focusY: 0,
            focusZ: geometry.wallHeight * 0.42,
            yaw: drainageYaw
          }
        };
        const target = targets[mode] || targets.complete;
        this.state.focusMode = mode;
        this.state.focusStartedAt = performance.now();
        this.showModelFocus(label || 'Modell aktualisiert');
        this.animateCamera(target);
      }

      showModelFocus(label) {
        this.modelFocusLabel.textContent = label;
        this.modelFocus.classList.remove('is-visible');
        this.stage.classList.remove('is-focusing');
        void this.stage.offsetWidth;
        this.modelFocus.classList.add('is-visible');
        this.stage.classList.add('is-focusing');
        if (this.focusTimer) clearTimeout(this.focusTimer);
        if (this.stageTimer) clearTimeout(this.stageTimer);
        this.focusTimer = setTimeout(() => this.modelFocus.classList.remove('is-visible'), 1350);
        this.stageTimer = setTimeout(() => this.stage.classList.remove('is-focusing'), 850);
      }

      animateCamera(target) {
        if (this.cameraAnimationFrame) cancelAnimationFrame(this.cameraAnimationFrame);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const start = {
          zoom: this.state.camera.zoom,
          focusX: this.state.camera.focusX,
          focusY: this.state.camera.focusY,
          focusZ: this.state.camera.focusZ,
          yaw: this.state.yaw
        };
        const startedAt = performance.now();
        const duration = reducedMotion ? 0 : 920;
        const renderFrame = (now) => {
          const progress = duration === 0 ? 1 : Math.min(1, (now - startedAt) / duration);
          const eased = 1 - Math.pow(1 - progress, 4);
          this.state.camera.zoom = start.zoom + (target.zoom - start.zoom) * eased;
          this.state.camera.focusX = start.focusX + (target.focusX - start.focusX) * eased;
          this.state.camera.focusY = start.focusY + (target.focusY - start.focusY) * eased;
          this.state.camera.focusZ = start.focusZ + (target.focusZ - start.focusZ) * eased;
          this.state.yaw = start.yaw + (target.yaw - start.yaw) * eased;
          this.drawModel();
          if (progress < 1) {
            this.cameraAnimationFrame = requestAnimationFrame(renderFrame);
          } else {
            this.cameraAnimationFrame = null;
          }
        };
        this.cameraAnimationFrame = requestAnimationFrame(renderFrame);
      }

      drawModel() {
        if (!this.canvasSize || !this.context) return;
        const ctx = this.context;
        const width = this.canvasSize.width;
        const height = this.canvasSize.height;
        ctx.clearRect(0, 0, width, height);

        const geometry = this.getModelGeometry();
        const building = geometry.building;
        const halfLength = geometry.halfLength;
        const halfDepth = geometry.halfDepth;
        const wallHeight = geometry.wallHeight;
        const roofRise = geometry.roofRise;
        const isMobileModel = window.matchMedia('(max-width: 740px)').matches;
        const centerX = width * 0.5;
        const centerY = height * (building === 'house' ? 0.62 : 0.57);
        const scale = isMobileModel
          ? Math.min(width / 8.4, height / 6.4)
          : Math.min(width / 10, height / 7.4);
        const accent = getComputedStyle(this).getPropertyValue('--gf-accent').trim() || '#04BF7B';
        const camera = this.state.camera;

        const project = ([x, y, z]) => {
          const cosine = Math.cos(this.state.yaw);
          const sine = Math.sin(this.state.yaw);
          const rotatedX = x * cosine - y * sine;
          const rotatedY = x * sine + y * cosine;
          const focusRotatedX = camera.focusX * cosine - camera.focusY * sine;
          const focusRotatedY = camera.focusX * sine + camera.focusY * cosine;
          return {
            x: centerX + (rotatedX - focusRotatedX) * scale * camera.zoom,
            y: centerY + ((rotatedY - focusRotatedY) * 0.48 - (z - camera.focusZ)) * scale * camera.zoom,
            depth: rotatedY
          };
        };

        const polygon = (points, fill, stroke, lineWidth = 1) => {
          const projected = points.map(project);
          ctx.beginPath();
          projected.forEach((point, index) => {
            if (index === 0) ctx.moveTo(point.x, point.y);
            else ctx.lineTo(point.x, point.y);
          });
          ctx.closePath();
          ctx.fillStyle = fill;
          ctx.fill();
          ctx.strokeStyle = stroke;
          ctx.lineWidth = lineWidth;
          ctx.stroke();
        };

        const line = (points, color, lineWidth = 1) => {
          const projected = points.map(project);
          ctx.beginPath();
          projected.forEach((point, index) => {
            if (index === 0) ctx.moveTo(point.x, point.y);
            else ctx.lineTo(point.x, point.y);
          });
          ctx.strokeStyle = color;
          ctx.lineWidth = lineWidth;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.stroke();
        };

        const backY = geometry.backY;
        const frontY = geometry.frontY;
        const leftX = geometry.leftX;
        const rightX = geometry.rightX;
        const edge = 'rgba(255,255,255,0.26)';
        const isHouse = building === 'house';
        const isShed = building === 'shed';
        const roofLeftX = isHouse ? leftX - 0.18 : isShed ? leftX - 0.14 : leftX;
        const roofRightX = isHouse ? rightX + 0.18 : isShed ? rightX + 0.14 : rightX;
        const roofFrontY = isHouse ? frontY - 0.17 : isShed ? frontY - 0.14 : frontY;
        const roofBackY = isHouse ? backY + 0.17 : isShed ? backY + 0.14 : backY;
        const ridgeHeight = wallHeight + roofRise + (isHouse ? 0.08 : isShed ? 0.06 : 0);

        if (building === 'carport') {
          polygon(
            [[leftX - 0.18, frontY - 0.18, 0], [rightX + 0.18, frontY - 0.18, 0], [rightX + 0.18, backY + 0.18, 0], [leftX - 0.18, backY + 0.18, 0]],
            'rgba(255,255,255,0.025)',
            'rgba(255,255,255,0.11)'
          );
          const panelCount = 7;
          for (let index = 0; index < panelCount; index += 1) {
            const panelLeft = leftX + ((rightX - leftX) / panelCount) * index;
            const panelRight = leftX + ((rightX - leftX) / panelCount) * (index + 1);
            polygon(
              [
                [panelLeft, frontY, wallHeight],
                [panelRight, frontY, wallHeight],
                [panelRight, backY, wallHeight + roofRise],
                [panelLeft, backY, wallHeight + roofRise]
              ],
              index % 2 === 0 ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.075)',
              'rgba(255,255,255,0.26)'
            );
          }
          [
            [leftX, frontY, wallHeight],
            [rightX, frontY, wallHeight],
            [leftX, backY, wallHeight + roofRise],
            [rightX, backY, wallHeight + roofRise]
          ].forEach(([x, y, top]) => line([[x, y, 0], [x, y, top]], 'rgba(255,255,255,0.68)', 4));
          line([[leftX, frontY, wallHeight], [rightX, frontY, wallHeight]], 'rgba(255,255,255,0.72)', 4);
          line([[leftX, backY, wallHeight + roofRise], [rightX, backY, wallHeight + roofRise]], 'rgba(255,255,255,0.62)', 4);
          line([[leftX, frontY, wallHeight], [leftX, backY, wallHeight + roofRise]], 'rgba(255,255,255,0.56)', 3);
          line([[rightX, frontY, wallHeight], [rightX, backY, wallHeight + roofRise]], 'rgba(255,255,255,0.56)', 3);
        } else {
          const buildingSurfaces = [
            {
              points: [[leftX, backY, 0], [rightX, backY, 0], [rightX, backY, wallHeight], [leftX, backY, wallHeight]],
              fill: isHouse
                ? 'rgba(235,237,230,0.9)'
                : isShed
                  ? 'rgba(203,174,126,0.9)'
                  : 'rgba(255,255,255,0.12)'
            },
            {
              points: [[leftX, frontY, 0], [rightX, frontY, 0], [rightX, frontY, wallHeight], [leftX, frontY, wallHeight]],
              fill: isHouse
                ? 'rgba(218,222,214,0.86)'
                : isShed
                  ? 'rgba(184,153,106,0.88)'
                  : 'rgba(255,255,255,0.13)'
            },
            {
              points: [[leftX, frontY, 0], [leftX, backY, 0], [leftX, backY, wallHeight], [leftX, 0, wallHeight + roofRise], [leftX, frontY, wallHeight]],
              fill: isHouse
                ? 'rgba(239,240,234,0.94)'
                : isShed
                  ? 'rgba(218,185,132,0.94)'
                  : 'rgba(255,255,255,0.11)'
            },
            {
              points: [[rightX, frontY, 0], [rightX, backY, 0], [rightX, backY, wallHeight], [rightX, 0, wallHeight + roofRise], [rightX, frontY, wallHeight]],
              fill: isHouse
                ? 'rgba(226,229,222,0.9)'
                : isShed
                  ? 'rgba(195,162,113,0.92)'
                  : 'rgba(255,255,255,0.1)',
              stroke: edge
            },
            {
              points: [[roofLeftX, roofFrontY, wallHeight], [roofRightX, roofFrontY, wallHeight], [roofRightX, 0, ridgeHeight], [roofLeftX, 0, ridgeHeight]],
              fill: isHouse
                ? 'rgba(25,28,28,0.96)'
                : isShed
                  ? 'rgba(29,32,31,0.97)'
                  : 'rgba(255,255,255,0.17)',
              stroke: isHouse || isShed ? 'rgba(255,255,255,0.48)' : 'rgba(255,255,255,0.38)'
            },
            {
              points: [[roofLeftX, roofBackY, wallHeight], [roofRightX, roofBackY, wallHeight], [roofRightX, 0, ridgeHeight], [roofLeftX, 0, ridgeHeight]],
              fill: isHouse
                ? 'rgba(17,20,20,0.94)'
                : isShed
                  ? 'rgba(20,23,22,0.95)'
                  : 'rgba(255,255,255,0.11)',
              stroke: isHouse || isShed ? 'rgba(255,255,255,0.34)' : 'rgba(255,255,255,0.3)'
            }
          ];

          buildingSurfaces
            .map((surface) => ({
              ...surface,
              depth: surface.points.reduce((sum, point) => sum + project(point).depth, 0) / surface.points.length
            }))
            .sort((firstSurface, secondSurface) => firstSurface.depth - secondSurface.depth)
            .forEach((surface) => polygon(surface.points, surface.fill, surface.stroke || edge));

          const leftFaceVisible = project([leftX, 0, wallHeight * 0.5]).depth >= project([rightX, 0, wallHeight * 0.5]).depth;
          const backFaceVisible = project([0, backY, wallHeight * 0.5]).depth >= project([0, frontY, wallHeight * 0.5]).depth;

          if (building === 'house') {
            const facadeY = backY + 0.025;
            const sideX = leftX - 0.025;
            const windowBottom = wallHeight * 0.34;
            const windowTop = wallHeight * 0.72;
            const frontWindowWidth = Math.min(0.72, halfLength * 0.2);
            const frontWindow = (center, widthValue, bottom, top) => {
              polygon(
                [
                  [center - widthValue, facadeY, bottom],
                  [center + widthValue, facadeY, bottom],
                  [center + widthValue, facadeY, top],
                  [center - widthValue, facadeY, top]
                ],
                'rgba(95,139,150,0.42)',
                'rgba(245,247,241,0.88)',
                2
              );
              line([[center, facadeY - 0.01, bottom], [center, facadeY - 0.01, top]], 'rgba(245,247,241,0.72)', 1);
              line(
                [[center - widthValue, facadeY - 0.01, bottom + (top - bottom) * 0.52], [center + widthValue, facadeY - 0.01, bottom + (top - bottom) * 0.52]],
                'rgba(245,247,241,0.62)',
                1
              );
              line(
                [[center - widthValue * 0.82, facadeY - 0.015, top - 0.06], [center + widthValue * 0.22, facadeY - 0.015, bottom + 0.08]],
                'rgba(255,255,255,0.18)',
                1
              );
            };

            if (backFaceVisible) {
              polygon(
                [[leftX, facadeY, 0.02], [rightX, facadeY, 0.02], [rightX, facadeY, 0.15], [leftX, facadeY, 0.15]],
                'rgba(33,37,36,0.62)',
                'rgba(255,255,255,0.18)'
              );

              frontWindow(-halfLength * 0.58, frontWindowWidth, windowBottom, windowTop);
              frontWindow(halfLength * 0.5, frontWindowWidth, windowBottom, windowTop);

              const doorCenter = -halfLength * 0.1;
              const doorHalfWidth = Math.min(0.42, halfLength * 0.12);
              const doorTop = wallHeight * 0.8;
              polygon(
                [
                  [doorCenter - doorHalfWidth, facadeY - 0.01, 0.06],
                  [doorCenter + doorHalfWidth, facadeY - 0.01, 0.06],
                  [doorCenter + doorHalfWidth, facadeY - 0.01, doorTop],
                  [doorCenter - doorHalfWidth, facadeY - 0.01, doorTop]
                ],
                'rgba(222,226,217,0.96)',
                'rgba(250,250,244,0.94)',
                2
              );
              line(
                [[doorCenter - doorHalfWidth * 0.36, facadeY - 0.02, 0.1], [doorCenter - doorHalfWidth * 0.36, facadeY - 0.02, doorTop]],
                'rgba(250,250,244,0.74)',
                1.5
              );
              line(
                [[doorCenter + doorHalfWidth * 0.62, facadeY - 0.035, doorTop * 0.46], [doorCenter + doorHalfWidth * 0.77, facadeY - 0.035, doorTop * 0.46]],
                accent,
                2
              );

              const canopyHalfWidth = doorHalfWidth + 0.2;
              const canopyZ = doorTop + 0.18;
              polygon(
                [
                  [doorCenter - canopyHalfWidth, facadeY, canopyZ],
                  [doorCenter + canopyHalfWidth, facadeY, canopyZ],
                  [doorCenter + canopyHalfWidth + 0.08, backY + 0.42, canopyZ - 0.07],
                  [doorCenter - canopyHalfWidth - 0.08, backY + 0.42, canopyZ - 0.07]
                ],
                'rgba(144,190,190,0.18)',
                'rgba(245,247,241,0.72)',
                1.5
              );
              line(
                [[doorCenter - canopyHalfWidth - 0.08, backY + 0.42, canopyZ - 0.07], [doorCenter - canopyHalfWidth, facadeY, doorTop - 0.02]],
                'rgba(245,247,241,0.5)',
                1
              );
              line(
                [[doorCenter + canopyHalfWidth + 0.08, backY + 0.42, canopyZ - 0.07], [doorCenter + canopyHalfWidth, facadeY, doorTop - 0.02]],
                'rgba(245,247,241,0.5)',
                1
              );
            }

            if (leftFaceVisible) {
              polygon(
                [[sideX, frontY, 0.02], [sideX, backY, 0.02], [sideX, backY, 0.15], [sideX, frontY, 0.15]],
                'rgba(27,31,30,0.5)',
                'rgba(255,255,255,0.15)'
              );
            }

            const sideWindow = (centerYValue, widthValue, bottom, top) => {
              polygon(
                [
                  [sideX, centerYValue - widthValue, bottom],
                  [sideX, centerYValue + widthValue, bottom],
                  [sideX, centerYValue + widthValue, top],
                  [sideX, centerYValue - widthValue, top]
                ],
                'rgba(80,125,137,0.38)',
                'rgba(246,247,241,0.76)',
                1.5
              );
              line(
                [[sideX - 0.01, centerYValue, bottom], [sideX - 0.01, centerYValue, top]],
                'rgba(246,247,241,0.62)',
                1
              );
            };
            const sideWindowWidth = Math.min(0.34, halfDepth * 0.16);
            if (leftFaceVisible) {
              sideWindow(-halfDepth * 0.42, sideWindowWidth, wallHeight * 0.36, wallHeight * 0.77);
              sideWindow(halfDepth * 0.34, sideWindowWidth, wallHeight * 0.36, wallHeight * 0.77);
            }

            const visibleRoofY = backFaceVisible ? roofBackY : roofFrontY;
            for (let row = 1; row <= 6; row += 1) {
              const t = row / 7;
              const y = visibleRoofY + (0 - visibleRoofY) * t;
              const z = wallHeight + (ridgeHeight - wallHeight) * t;
              line(
                [[roofLeftX, y, z + 0.008], [roofRightX, y, z + 0.008]],
                'rgba(255,255,255,0.13)',
                row === 6 ? 1.4 : 1
              );
            }

            const tileColumns = 13;
            for (let column = 1; column < tileColumns; column += 1) {
              const x = roofLeftX + ((roofRightX - roofLeftX) / tileColumns) * column;
              line(
                [[x, visibleRoofY, wallHeight + 0.01], [x, 0, ridgeHeight + 0.01]],
                'rgba(255,255,255,0.095)',
                0.8
              );
            }

            line([[roofLeftX, visibleRoofY, wallHeight], [roofRightX, visibleRoofY, wallHeight]], 'rgba(246,247,240,0.72)', 3);
            const visibleRoofX = leftFaceVisible ? roofLeftX : roofRightX;
            line(
              [[visibleRoofX, roofFrontY, wallHeight], [visibleRoofX, 0, ridgeHeight], [visibleRoofX, roofBackY, wallHeight]],
              'rgba(246,247,240,0.82)',
              3
            );
            line([[roofLeftX, 0, ridgeHeight], [roofRightX, 0, ridgeHeight]], 'rgba(255,255,255,0.52)', 2.5);

            const visibleWallY = backFaceVisible ? backY : frontY;
            for (let rafter = 1; rafter < 12; rafter += 1) {
              const x = roofLeftX + ((roofRightX - roofLeftX) / 12) * rafter;
              line(
                [[x, visibleRoofY, wallHeight - 0.01], [x, visibleWallY, wallHeight - 0.13]],
                'rgba(246,247,240,0.38)',
                1.4
              );
            }
          }

          if (building === 'garage') {
            const garageDoorOuter = halfDepth * 0.84;
            const garageDoorGap = 0.11;
            const garageDoorTop = wallHeight * 0.82;
            const garageDoors = [
              [-garageDoorOuter, -garageDoorGap],
              [garageDoorGap, garageDoorOuter]
            ];

            garageDoors.forEach(([doorStart, doorEnd]) => {
              polygon(
                [
                  [leftX - 0.03, doorStart, 0.04],
                  [leftX - 0.03, doorEnd, 0.04],
                  [leftX - 0.03, doorEnd, garageDoorTop],
                  [leftX - 0.03, doorStart, garageDoorTop]
                ],
                'rgba(255,255,255,0.16)',
                'rgba(255,255,255,0.68)',
                2
              );

              [0.27, 0.51, 0.75].forEach((sectionHeight) => {
                line(
                  [
                    [leftX - 0.04, doorStart, garageDoorTop * sectionHeight],
                    [leftX - 0.04, doorEnd, garageDoorTop * sectionHeight]
                  ],
                  'rgba(255,255,255,0.32)',
                  1
                );
              });
            });

            [-halfDepth * 0.95, -halfDepth * 0.91, halfDepth * 0.91, halfDepth * 0.95].forEach((y) => {
              line(
                [[leftX - 0.035, y, 0.08], [leftX - 0.035, y, wallHeight * 0.96]],
                'rgba(255,255,255,0.2)',
                1
              );
            });

            line(
              [[leftX - 0.04, -garageDoorGap, 0.04], [leftX - 0.04, -garageDoorGap, garageDoorTop]],
              'rgba(255,255,255,0.72)',
              3
            );
            line(
              [[leftX - 0.04, garageDoorGap, 0.04], [leftX - 0.04, garageDoorGap, garageDoorTop]],
              'rgba(255,255,255,0.72)',
              3
            );
            line(
              [
                [leftX - 0.08, frontY, wallHeight],
                [leftX - 0.08, 0, wallHeight + roofRise],
                [leftX - 0.08, backY, wallHeight]
              ],
              'rgba(255,255,255,0.76)',
              4
            );
          }

          if (building === 'shed') {
            const shedFaceX = leftX - 0.035;
            const shedReverseFaceX = rightX + 0.035;
            const shedSideY = backY + 0.025;
            const shedFrontY = frontY - 0.025;
            const woodEdge = 'rgba(247,224,184,0.76)';
            const woodLine = 'rgba(255,236,202,0.28)';
            const darkHardware = 'rgba(25,29,27,0.84)';
            const doorHalfWidth = Math.min(0.84, halfDepth * 0.48);
            const doorTop = wallHeight * 0.92;
            const visibleShedFaceX = leftFaceVisible ? shedFaceX : shedReverseFaceX;
            const visibleShedSideY = backFaceVisible ? shedSideY : shedFrontY;

            for (let row = 1; row < 8; row += 1) {
              const z = (wallHeight / 8) * row;
              line(
                [[visibleShedFaceX, frontY + 0.04, z], [visibleShedFaceX, backY - 0.04, z]],
                woodLine,
                1
              );
              line(
                [[leftX + 0.04, visibleShedSideY, z], [rightX - 0.04, visibleShedSideY, z]],
                'rgba(255,236,202,0.22)',
                1
              );
            }

            [0.24, 0.48, 0.72].forEach((t) => {
              const gableZ = wallHeight + roofRise * t;
              const gableHalfWidth = halfDepth * (1 - t);
              line(
                [[visibleShedFaceX, -gableHalfWidth, gableZ], [visibleShedFaceX, gableHalfWidth, gableZ]],
                woodLine,
                1
              );
            });

            if (leftFaceVisible) {
              polygon(
                [
                  [shedFaceX - 0.01, -doorHalfWidth, 0.05],
                  [shedFaceX - 0.01, doorHalfWidth, 0.05],
                  [shedFaceX - 0.01, doorHalfWidth, doorTop],
                  [shedFaceX - 0.01, -doorHalfWidth, doorTop]
                ],
                'rgba(194,160,109,0.96)',
                woodEdge,
                2.2
              );

              for (let board = 1; board < 7; board += 1) {
                const boardZ = 0.05 + ((doorTop - 0.05) / 7) * board;
                line(
                  [[shedFaceX - 0.02, -doorHalfWidth, boardZ], [shedFaceX - 0.02, doorHalfWidth, boardZ]],
                  'rgba(255,237,205,0.3)',
                  1
                );
              }

              line(
                [[shedFaceX - 0.025, 0, 0.06], [shedFaceX - 0.025, 0, doorTop]],
                woodEdge,
                2.2
              );
              line(
                [
                  [shedFaceX - 0.03, -doorHalfWidth + 0.08, 0.16],
                  [shedFaceX - 0.03, -0.08, doorTop - 0.12]
                ],
                'rgba(255,235,199,0.35)',
                1.4
              );
              line(
                [
                  [shedFaceX - 0.03, 0.08, doorTop - 0.12],
                  [shedFaceX - 0.03, doorHalfWidth - 0.08, 0.16]
                ],
                'rgba(255,235,199,0.35)',
                1.4
              );

              [-doorHalfWidth + 0.08, doorHalfWidth - 0.08].forEach((hingeY) => {
                [0.3, doorTop * 0.55, doorTop - 0.2].forEach((hingeZ) => {
                  const hingeDirection = hingeY < 0 ? 1 : -1;
                  line(
                    [
                      [shedFaceX - 0.04, hingeY, hingeZ],
                      [shedFaceX - 0.04, hingeY + 0.18 * hingeDirection, hingeZ]
                    ],
                    darkHardware,
                    2.4
                  );
                });
              });

              line(
                [[shedFaceX - 0.05, -0.1, doorTop * 0.5], [shedFaceX - 0.05, 0.1, doorTop * 0.5]],
                darkHardware,
                3.2
              );
              line(
                [[shedFaceX - 0.04, -doorHalfWidth - 0.08, 0.03], [shedFaceX - 0.04, doorHalfWidth + 0.08, 0.03]],
                woodEdge,
                3
              );
            }

            const windowCenterX = halfLength * 0.42;
            const windowHalfWidth = Math.min(0.42, halfLength * 0.18);
            const windowBottom = wallHeight * 0.35;
            const windowTop = wallHeight * 0.74;
            if (backFaceVisible) {
              polygon(
                [
                  [windowCenterX - windowHalfWidth, shedSideY + 0.01, windowBottom],
                  [windowCenterX + windowHalfWidth, shedSideY + 0.01, windowBottom],
                  [windowCenterX + windowHalfWidth, shedSideY + 0.01, windowTop],
                  [windowCenterX - windowHalfWidth, shedSideY + 0.01, windowTop]
                ],
                'rgba(93,133,139,0.42)',
                'rgba(248,226,188,0.88)',
                2
              );
              line(
                [[windowCenterX, shedSideY + 0.02, windowBottom], [windowCenterX, shedSideY + 0.02, windowTop]],
                'rgba(248,226,188,0.72)',
                1.2
              );
              line(
                [
                  [windowCenterX - windowHalfWidth, shedSideY + 0.02, windowBottom + (windowTop - windowBottom) * 0.5],
                  [windowCenterX + windowHalfWidth, shedSideY + 0.02, windowBottom + (windowTop - windowBottom) * 0.5]
                ],
                'rgba(248,226,188,0.72)',
                1.2
              );
            }

            polygon(
              [[leftX, visibleShedSideY, 0.02], [rightX, visibleShedSideY, 0.02], [rightX, visibleShedSideY, 0.13], [leftX, visibleShedSideY, 0.13]],
              'rgba(29,33,31,0.56)',
              'rgba(255,255,255,0.14)'
            );

            const visibleShedRoofY = backFaceVisible ? roofBackY : roofFrontY;
            for (let row = 1; row <= 5; row += 1) {
              const t = row / 6;
              const y = visibleShedRoofY + (0 - visibleShedRoofY) * t;
              const z = wallHeight + (ridgeHeight - wallHeight) * t;
              line(
                [[roofLeftX, y, z + 0.008], [roofRightX, y, z + 0.008]],
                'rgba(255,255,255,0.11)',
                1
              );
            }

            const shedRoofColumns = 9;
            for (let column = 1; column < shedRoofColumns; column += 1) {
              const x = roofLeftX + ((roofRightX - roofLeftX) / shedRoofColumns) * column;
              line(
                [[x, visibleShedRoofY, wallHeight + 0.01], [x, 0, ridgeHeight + 0.01]],
                'rgba(255,255,255,0.075)',
                0.8
              );
            }

            const visibleShedRoofX = leftFaceVisible ? roofLeftX : roofRightX;
            line(
              [[visibleShedRoofX, roofFrontY, wallHeight], [visibleShedRoofX, 0, ridgeHeight], [visibleShedRoofX, roofBackY, wallHeight]],
              woodEdge,
              3.2
            );
            line([[roofLeftX, visibleShedRoofY, wallHeight], [roofRightX, visibleShedRoofY, wallHeight]], woodEdge, 2.4);
            line([[roofLeftX, 0, ridgeHeight], [roofRightX, 0, ridgeHeight]], 'rgba(255,255,255,0.4)', 2);
            line(
              [[visibleShedFaceX, frontY, 0.06], [visibleShedFaceX, frontY, wallHeight], [visibleShedFaceX, 0, wallHeight + roofRise], [visibleShedFaceX, backY, wallHeight], [visibleShedFaceX, backY, 0.06]],
              'rgba(248,226,188,0.74)',
              2.6
            );
          }
        }

        const downpipeXs = [rightX - 0.08];
        const drainageAtFront = building === 'carport';
        const gutterY = drainageAtFront ? frontY - 0.06 : backY + 0.06;
        const downpipeElbowY = drainageAtFront ? frontY - 0.18 : backY + 0.18;
        const downpipeWidth = this.state.pipeSize === 100 ? 9 : 7;
        const pulseAge = performance.now() - this.state.focusStartedAt;
        const pulseProgress = Math.max(0, Math.min(1, pulseAge / 920));
        const pulseWidth = 15 - pulseProgress * 5;
        const pulseOpacity = Math.max(0, 0.34 * (1 - pulseProgress));
        const neutralDrainageColor = 'rgba(190,201,195,0.82)';
        const gutterIsActive = !this.state.route || this.state.route === 'complete' || this.state.route === 'gutter';
        const downpipeIsActive = !this.state.route || this.state.route === 'complete' || this.state.route === 'downpipe';
        const gutterColor = gutterIsActive ? accent : neutralDrainageColor;
        const downpipeColor = downpipeIsActive ? accent : neutralDrainageColor;
        const gutterHighlight = gutterIsActive ? 'rgba(255,255,255,0.58)' : 'rgba(255,255,255,0.24)';
        if (this.state.focusMode === 'gutter' || this.state.focusMode === 'complete') {
          line(
            [[leftX, gutterY, wallHeight], [rightX, gutterY, wallHeight]],
            `rgba(4,191,123,${pulseOpacity})`,
            pulseWidth
          );
        }
        if (this.state.focusMode === 'downpipe' || this.state.focusMode === 'complete') {
          downpipeXs.forEach((downpipeX) => {
            line(
              [
                [downpipeX, gutterY, wallHeight],
                [downpipeX, downpipeElbowY, wallHeight - 0.28],
                [downpipeX, downpipeElbowY, 0.18]
              ],
              `rgba(4,191,123,${pulseOpacity})`,
              pulseWidth
            );
          });
        }

        line([[leftX, gutterY, wallHeight], [rightX, gutterY, wallHeight]], gutterColor, 7);
        line([[leftX, gutterY, wallHeight + 0.01], [rightX, gutterY, wallHeight + 0.01]], gutterHighlight, 1);

        downpipeXs.forEach((downpipeX) => {
          line(
            [
              [downpipeX, gutterY, wallHeight],
              [downpipeX, downpipeElbowY, wallHeight - 0.28],
              [downpipeX, downpipeElbowY, 0.18]
            ],
            downpipeColor,
            downpipeWidth
          );
        });

        const gutterStart = project([leftX, gutterY, wallHeight]);
        const gutterEnd = project([rightX, gutterY, wallHeight]);
        ctx.fillStyle = gutterColor;
        [gutterStart, gutterEnd].forEach((point) => {
          ctx.beginPath();
          ctx.arc(point.x, point.y, 4.5, 0, Math.PI * 2);
          ctx.fill();
        });

        const groundLeft = project([leftX - 0.35, frontY - 0.25, -0.25]);
        const groundRight = project([rightX + 0.35, frontY - 0.25, -0.25]);
        ctx.beginPath();
        ctx.moveTo(groundLeft.x, groundLeft.y);
        ctx.lineTo(groundRight.x, groundRight.y);
        ctx.strokeStyle = 'rgba(255,255,255,0.18)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 6]);
        ctx.stroke();
        ctx.setLineDash([]);

        if (this.state.step >= 3) {
          const backFaceVisible = project([0, backY, 0]).depth >= project([0, frontY, 0]).depth;
          const leftFaceVisible = project([leftX, 0, 0]).depth >= project([rightX, 0, 0]).depth;
          const visibleY = backFaceVisible ? backY : frontY;
          const dimensionY = visibleY + (backFaceVisible ? 0.58 : -0.58);
          const visibleX = leftFaceVisible ? leftX : rightX;
          const slopeX = (leftFaceVisible ? roofLeftX : roofRightX) + (leftFaceVisible ? -0.34 : 0.34);
          const guideColor = 'rgba(255,255,255,0.26)';
          const dimensionColor = 'rgba(255,255,255,0.82)';

          const screenLine = (start, end, color, lineWidth = 1, dash = []) => {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(start.x, start.y);
            ctx.lineTo(end.x, end.y);
            ctx.strokeStyle = color;
            ctx.lineWidth = lineWidth;
            ctx.lineCap = 'round';
            ctx.setLineDash(dash);
            ctx.stroke();
            ctx.restore();
          };

          const drawDimension = (startWorld, endWorld, key, value) => {
            const start = project(startWorld);
            const end = project(endWorld);
            const deltaX = end.x - start.x;
            const deltaY = end.y - start.y;
            const length = Math.hypot(deltaX, deltaY);
            const dimensionCollapsed = length < 24;
            const normalX = dimensionCollapsed ? 0 : -deltaY / length;
            const normalY = dimensionCollapsed ? -1 : deltaX / length;
            const tick = isMobileModel ? 5 : 7;
            if (!dimensionCollapsed) {
              screenLine(start, end, dimensionColor, 1.4);
              screenLine(
                { x: start.x - normalX * tick, y: start.y - normalY * tick },
                { x: start.x + normalX * tick, y: start.y + normalY * tick },
                dimensionColor,
                1.4
              );
              screenLine(
                { x: end.x - normalX * tick, y: end.y - normalY * tick },
                { x: end.x + normalX * tick, y: end.y + normalY * tick },
                dimensionColor,
                1.4
              );
            }

            const labelX = (start.x + end.x) * 0.5 + normalX * (isMobileModel ? 16 : 18);
            const labelY = (start.y + end.y) * 0.5 + normalY * (isMobileModel ? 16 : 18);
            const keySize = isMobileModel ? 21 : 24;
            const labelHeight = keySize;
            const valueFont = isMobileModel ? 10 : 11;
            ctx.save();
            ctx.font = `700 ${valueFont}px Barlow, sans-serif`;
            const valueWidth = Math.ceil(ctx.measureText(value).width);
            const labelWidth = keySize + valueWidth + (isMobileModel ? 14 : 18);
            const labelLeft = Math.max(4, Math.min(width - labelWidth - 4, labelX - labelWidth * 0.5));
            const labelTop = Math.max(4, Math.min(height - labelHeight - 4, labelY - labelHeight * 0.5));
            ctx.fillStyle = 'rgba(24,27,26,0.94)';
            ctx.fillRect(labelLeft, labelTop, labelWidth, labelHeight);
            ctx.strokeStyle = 'rgba(255,255,255,0.28)';
            ctx.lineWidth = 1;
            ctx.strokeRect(labelLeft + 0.5, labelTop + 0.5, labelWidth - 1, labelHeight - 1);
            ctx.fillStyle = accent;
            ctx.fillRect(labelLeft, labelTop, keySize, labelHeight);
            ctx.fillStyle = '#07130f';
            ctx.font = `900 ${isMobileModel ? 11 : 12}px Barlow, sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(key, labelLeft + keySize * 0.5, labelTop + labelHeight * 0.5 + 0.5);
            ctx.fillStyle = '#ffffff';
            ctx.font = `700 ${valueFont}px Barlow, sans-serif`;
            ctx.textAlign = 'left';
            ctx.fillText(value, labelLeft + keySize + (isMobileModel ? 6 : 8), labelTop + labelHeight * 0.5 + 0.5);
            ctx.restore();
          };

          const lengthGuideStart = project([leftX, visibleY, -0.04]);
          const lengthGuideEnd = project([rightX, visibleY, -0.04]);
          const lengthStart = project([leftX, dimensionY, -0.14]);
          const lengthEnd = project([rightX, dimensionY, -0.14]);
          screenLine(lengthGuideStart, lengthStart, guideColor, 1, [3, 4]);
          screenLine(lengthGuideEnd, lengthEnd, guideColor, 1, [3, 4]);
          drawDimension(
            [leftX, dimensionY, -0.14],
            [rightX, dimensionY, -0.14],
            'A',
            this.formatMeters(this.state.roofLength)
          );

          const slopeRoofStart = building === 'carport'
            ? [visibleX, frontY, wallHeight]
            : [visibleX, roofBackY, wallHeight];
          const slopeRoofEnd = building === 'carport'
            ? [visibleX, backY, wallHeight + roofRise]
            : [visibleX, 0, ridgeHeight];
          const slopeStart = building === 'carport'
            ? [slopeX, frontY, wallHeight]
            : [slopeX, roofBackY, wallHeight];
          const slopeEnd = building === 'carport'
            ? [slopeX, backY, wallHeight + roofRise]
            : [slopeX, 0, ridgeHeight];
          screenLine(project(slopeRoofStart), project(slopeStart), guideColor, 1, [3, 4]);
          screenLine(project(slopeRoofEnd), project(slopeEnd), guideColor, 1, [3, 4]);
          drawDimension(
            slopeStart,
            slopeEnd,
            'B',
            this.formatMeters(this.state.roofDepth)
          );
        }

        if (!isMobileModel) {
          ctx.fillStyle = 'rgba(255,255,255,0.52)';
          ctx.font = '600 11px Barlow, sans-serif';
          ctx.textAlign = 'center';
          ctx.fillText(this.buildingNames[building].toUpperCase(), width * 0.5, height * 0.93);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
